<template lang="html">
  
  <header>
    <div class="logo-container">
      <router-link :to="'/' + switchLanguage">
        <img src="../../assets/images/logo-header@2x.png" alt="Maire MyReplast">
      </router-link>
    </div>
    <nav>
      <a class="external" href="https://www.groupmaire.com/" target="_blank">groupmaire.com</a>
      <a class="external" href="http://www.nextchem.com" target="_blank">nextchem.com</a>
      <ul>
        <li class="link home-menu"  >
          <router-link 
            :to="'/' + switchLanguage + '/'"
            exact
            class="home"
          >
            <b>{{ $t("message.nav_home") }}</b>
          </router-link>
        </li>
        <li class="sub-nav-parent prod-menu" >
          <p class="sub-menu"><b>{{ $t("message.nav_product") }}</b></p>
          <div class="sub-nav">
            <router-link 
              :to="'/' + switchLanguage + '/granulate'"
              exact              
            >
              {{ $t("message.nav_product_beads") }}
            </router-link>
            <router-link 
              :to="'/' + switchLanguage + '/flakes'"
              exact
            >
              {{ $t("message.nav_product_flakes") }}
            </router-link>
          </div>
        </li>
        <li @click="scrollToFooter" class="scroll-to" >
          <a>
            <b>{{ $t("message.nav_contact") }}</b>
          </a>
        </li>
      </ul>
      <div class="menu-lang-switcher" :class="isOpen ? 'open' : ''">
        <div class="current-lang" @click="toggleSwitch()" >
          <span class="current-lang-indicator">IT</span>
        </div>
        <div class="drop-lang">
          <div @click="changeLanguage('it')">
            <router-link :to="'/it' + '/' + `${this.$route.path.split('/')[2] !== undefined ? this.$route.path.split('/')[2] : ''}`">
              <p class="option">
                <span class="language">IT</span>
              </p>
            </router-link>
          </div>
          <div @click="changeLanguage('en')">
            <router-link :to="'/en' + '/' + `${this.$route.path.split('/')[2] !== undefined ? this.$route.path.split('/')[2] : ''}`">
              <p class="option">
                <span class="language">EN</span>
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
    <MenuMobile 
      :isOpenMenu.sync="isOpenMenu"
      :changeLanguage="changeLanguage" 
      :switchLanguage="switchLanguage"
      :toggleOpen="toggleOpen" 
      :toggleSwitch="toggleSwitch" 
      :isOpen="isOpen"
    />
  </header>
  
</template>

<script>
import MenuMobile from "./Menu.vue";
export default {
  props: ["lang"],
  components: {
    MenuMobile: MenuMobile,
  },
  data() {
    return {
      scrollPosition: null,
      currentComponent: "",
      switchLanguage: "it",
      isOpen: false,
      isOpenMenu: false,
    };
  },
  mounted() {
    console.log("myreplast-#");
  },
  destroyed() {},
  methods: {
    changeLanguage(lang) {
      this.switchLanguage = lang;

      // https://kazupon.github.io/vue-i18n/en/sfc.html
      this.$i18n.locale = lang;
      this.currentComponent = this.$route.path.split("/")[2];
      this.isOpen = !this.isOpen;
      let current = document.querySelectorAll(".current-lang-indicator");
      for (var i = 0; i < current.length; i++) {
        current[i].innerHTML = lang;
      }

      this.$emit("updateParent", this.switchLanguage);
    },
    toggleSwitch() {
      this.isOpen = !this.isOpen;
    },
    toggleOpen() {
      this.isOpenMenu = !this.isOpenMenu;
      document.body.classList.toggle("lock");
    },
    scrollToFooter() {
      let footer = document.querySelector("footer");
      footer.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    },
  },
  computed: {
    isActive() {
      return (
        this.$route.name === "en.flakes" ||
        this.$route.name === "it.flakes" ||
        this.$route.name === "en.beads" ||
        this.$route.name === "it.beads"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  position: sticky;
  top: 0;
  height: 75px;
  padding: 0 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 4;
  background-color: #fff;
  .logo-container {
    position: relative;
    width: 180px;
    flex: 1 0 180px;
    max-width: 180px;
    @media screen and( max-width: 900px) {
      width: 150px;
      flex: 1 0 150px;
      max-width: 150px;
    }
    img {
      display: block;
      width: 100%;
    }
  }
  @media screen and( max-width: 1100px) {
    padding: 0 60px;
  }
  @media screen and( max-width: 900px) {
    padding: 0 20px;
  }
}
.external {
  font-size: 16px;
  margin-left: 30px;
  @media screen and( max-width: 1100px) {
    margin-left: 15px;
  }
}
nav {
  height: 75px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and( max-width: 900px) {
    display: none;
  }
  ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    li {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 75px;
      &.scroll-to {
        cursor: pointer;
      }
      &.sub-nav-parent {
        p.sub-menu {
          padding: 0 8px;
        }
        &.selected {
          p.sub-menu {
            border-left: 2px solid #68a926;
          }
        }
      }
      a {
        padding: 0 8px;
        margin: 0 30px;
        line-height: 35px;
        display: block;
        @media screen and( max-width: 1100px) {
          margin: 0 15px;
        }
      }
      &.selected {
        a.home {
          border-left: 2px solid #68a926;
        }
      }
    }
    .sub-nav {
      position: absolute;
      opacity: 0;
      top: 95px;
      height: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      padding: 20px 20px;
      border-radius: 5px;
      box-shadow: 0 0 10px 5px rgba($color: #000000, $alpha: 0.1);
      pointer-events: none;
      transition: opacity 0.5s ease-out, top 0.5s ease-out;
      a {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
  .sub-nav-parent {
    p {
      line-height: 35px;
      cursor: pointer;
    }
    &:hover {
      .sub-nav {
        opacity: 1;
        top: 75px;
        pointer-events: auto;
      }
    }
  }
  .menu-lang-switcher {
    position: relative;
    .current-lang {
      position: relative;
      line-height: 35px;
      padding: 0 10px;
      text-transform: uppercase;
      width: 50px;
      text-align: left;
      z-index: 3;
      cursor: pointer;
      font-weight: 700;
      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4px 0 4px;
        border-color: #33586e transparent transparent transparent;
        right: 10px;
        top: 50%;
        margin-top: -3px;
        transform: rotate(0deg);
        transform-origin: 50% 50%;
        transition: transform 0.5s ease-out;
      }
    }
    .drop-lang {
      position: absolute;
      padding: 55px 10px 10px;
      top: 0;
      background: #fff;
      width: 50px;
      text-align: left;
      opacity: 0;
      transition: opacity 0.5s ease-out;
      a {
        line-height: 25px;
      }
    }
    &.open {
      .drop-lang {
        opacity: 1;
      }
      .current-lang {
        &::after {
          transform: rotate(-180deg);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?3ee1fe31